import { DTOError } from 'src/error/errors/DTOError';

import type { Availability } from './types';

export const availabilityDTO = (data: unknown): Availability => {
  if (data && typeof data === 'object') {
    return {
      flight:
        'flight' in data &&
        (data.flight === 'n/a' ||
          data.flight === 'few' ||
          data.flight === 'middle' ||
          data.flight === 'many')
          ? data.flight
          : null,
      hotel:
        'hotel' in data &&
        (data.hotel === 'n/a' ||
          data.hotel === 'few' ||
          data.hotel === 'middle' ||
          data.hotel === 'many')
          ? data.hotel
          : null,
      tooltip:
        'tooltip' in data && typeof data.tooltip === 'string'
          ? data.tooltip
          : null,
    };
  }

  throw new DTOError('availabilityDTO', data);
};
